import {
  teacherCreateAssignment,
  teacherGetAssignmentStudents,
  teacherGetAssignmentStudentsGrades,
  teacherUpdateAssignment,
  teacherDeleteAssignment,
} from '@school_ify/schoolify-repository/src/teacher/repositories/assignmentRepository';
import { teacherUpdateGradeMark } from '@school_ify/schoolify-repository/src/teacher/repositories/gradeRepository';
import {
  TeacherUpdateAssignmentMutationVariables,
  TeacherDeleteAssignmentMutationVariables,
  TeacherAssignmentInsertMutationVariables,
  TeacherAssignmentStudentGradesQuery,
  TeacherAssignmentStudentGradesQueryVariables,
  TeacherGradeUpdateMarkMutationVariables,
} from '@school_ify/schoolify-repository/src/teacher/types';
import { studentOrTeacherToggleAssignment } from '@school_ify/schoolify-repository/src/student_teacher/repositories/assignmentRepository';
import { getAssignments } from '@school_ify/schoolify-repository/src/shared/repositories/assignmentRepository';
import {
  AssignmentsQuery,
  AssignmentTypeEnum,
} from '@school_ify/schoolify-repository/src/shared/types';
import { StudentOrTeacherAssignmentToggleMutationVariables } from '@school_ify/schoolify-repository/src/student_teacher/types';

export interface SingleAssignmentsInterface {
  readonly id?: string;
  readonly title?: string;
  readonly description?: string;
  readonly duration?: number;
  readonly is_gradeable?: boolean;
  readonly is_completed?: boolean;
  readonly due_at?: string;
  readonly submited_by?: any;
  readonly assignment_type?: { readonly name: string; readonly icon?: string };
}

interface groupByDateInterface {
  overdue: SingleAssignmentsInterface[];
  today: SingleAssignmentsInterface[];
  tomorrow: SingleAssignmentsInterface[];
}

class AssignmentsService {
  public async getAssignments(arg: any): Promise<AssignmentsQuery> {
    try {
      return await getAssignments(arg);
    } catch (err) {
      throw new Error(`Teacher assignment error: ${err.message}`);
    }
  }

  public async getStudentAssignments(arg: any): Promise<TeacherAssignmentStudentGradesQuery> {
    try {
      return await teacherGetAssignmentStudents(arg);
    } catch (err) {
      throw new Error(`Login error: ${err}`);
    }
  }

  // TODO ask sebi to add interface just for singleAssignment - without totalCount
  public groupByDate(assignments: AssignmentsQuery | any): groupByDateInterface {
    const today = new Date();
    const lessons: groupByDateInterface = {
      overdue: [],
      today: [],
      tomorrow: [],
    };

    assignments.assignments.forEach((singleAssignment: SingleAssignmentsInterface) => {
      const assignmentDate = new Date(singleAssignment.due_at);
      if (assignmentDate === today) lessons.today.push(singleAssignment);
      else if (assignmentDate < today) lessons.overdue.push(singleAssignment);
      else lessons.tomorrow.push(singleAssignment);
    });

    return lessons;
  }

  public async addAssignment(
    variable: TeacherAssignmentInsertMutationVariables
  ): Promise<Readonly<any>> {
    try {
      const muation = await teacherCreateAssignment(variable);
      return muation;
    } catch (err) {
      throw new Error(`Teacher adding assignment error: ${err}`);
    }
  }

  public getAssignmentTypes(): AssignmentTypeEnum[] {
    return [
      // @ts-ignore
      AssignmentTypeEnum.EXAM,
      // @ts-ignore
      AssignmentTypeEnum.GROUP,
      // @ts-ignore
      AssignmentTypeEnum.HOMEWORK,
      // @ts-ignore
      AssignmentTypeEnum.ONLINE,
    ];
  }

  public async getTeacherCassStudentsQuery(assignment_id) {
    const arg: TeacherAssignmentStudentGradesQueryVariables = {
      assignment_id,
    };
    try {
      const data = await teacherGetAssignmentStudentsGrades(arg);
      return data;
    } catch (err) {
      throw new Error(`Teacher getting student for a assignment error: ${err}`);
    }
  }

  public async updateStudentMark(data: TeacherGradeUpdateMarkMutationVariables) {
    try {
      const success = await teacherUpdateGradeMark(data);
      return success;
    } catch (err) {
      throw new Error(`Update student mark grade: ${err}`);
    }
  }
  // teacherCompleteAssignment

  public async toggleTeacherAssignment(data: StudentOrTeacherAssignmentToggleMutationVariables) {
    try {
      await studentOrTeacherToggleAssignment(data);
    } catch (err) {
      throw new Error(`Update student mark grade: ${err}`);
    }
  }

  public async toggleStudentCompleteAssignment(data: any) {
    try {
      await studentOrTeacherToggleAssignment(data);
    } catch (err) {
      throw new Error(`Toggle assignments error: ${err}`);
    }
  }

  public async updateAssignment(payload: TeacherUpdateAssignmentMutationVariables) {
    try {
      const data = await teacherUpdateAssignment(payload);
      return data;
    } catch (err) {
      throw new Error(`update assignments error: ${err}`);
    }
  }

  public async deleteAssignment(payload: TeacherDeleteAssignmentMutationVariables) {
    try {
      await teacherDeleteAssignment(payload);
    } catch (err) {
      throw new Error(`update assignments error: ${err}`);
    }
  }
}

export default new AssignmentsService();
// function teacherAssignmentsQuery(arg: any): AssignmentsQuery | PromiseLike<AssignmentsQuery> {
//   throw new Error('Function not implemented.');
// }
